import React from "react";
import { PROJECTS } from "../data";
import Container from "../components/container";
import HeroSmall from "../components/hero-small";
import Projects from "../components/homepage-projects";

const About = props => (
  <main>
    <HeroSmall 
      title="Projects Worth Living For"
      desc="Our projects are a result of joined forces from various fields combined with creativity, precision, and dedication." 
    />

    <Projects projects={PROJECTS} />
  </main>
);

export default About;



// WEBPACK FOOTER //
// ./src/pages/projects.js